import { render, staticRenderFns } from "./vitransfer.vue?vue&type=template&id=b693b946&scoped=true"
import script from "./vitransfer.vue?vue&type=script&lang=js"
export * from "./vitransfer.vue?vue&type=script&lang=js"
import style0 from "./vitransfer.vue?vue&type=style&index=0&id=b693b946&prod&lang=css"
import style1 from "./vitransfer.vue?vue&type=style&index=1&id=b693b946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b693b946",
  null
  
)

export default component.exports